import React from 'react'
import {css} from '@emotion/react'
import {Link} from 'gatsby'
import Button from './button'
import {Logo, Initials, Instagram, Twitter} from './svg'

const Header = ({formRef}) => {
    const scrollToNewsletter = () => {
        // @TODO use refs instead?
        const element = formRef?.current
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
            })
        }
        // quick and dirty focus after scroll
        setTimeout(() => element.focus(), 600)
    }

    return (
        <header
            css={css`
                display: flex;
                justify-content: space-between;
                align-items: 'center';
                padding: 2rem;
                position: sticky;
                top: 0;
                z-index: 100;
            `}
        >
            <Link to="/" className="flex align-middle">
                <Logo className="fill-white w-52 hidden sm:block drop-shadow-blue hover:fill-red" />
                <Initials className="fill-white w-full sm:hidden drop-shadow-blue hover:fill-red" />
            </Link>
            <div className="flex">
                <a
                    href="https://www.instagram.com/deepmay_io"
                    className="hidden xs:block mr-4 sm:mt-2"
                >
                    <span className="sr-only">Instagram</span>
                    <Instagram className="w-6 h-6 drop-shadow-blue fill-white hover:fill-red" />
                </a>
                <a
                    href="https://www.twitter.com/deepmay_io"
                    className="hidden xs:block mr-8 sm:mt-2"
                >
                    <span className="sr-only">Twitter</span>
                    <Twitter className="w-6 h-6 drop-shadow-blue fill-white hover:fill-red" />
                </a>
                <Button
                    css={css`
                        background-color: white;

                        &:hover {
                            background-color: black;
                            color: white;
                            border-color: white;
                        }
                    `}
                    className="text-xs sm:text-base"
                    onClick={scrollToNewsletter}
                >
                    Get updates
                </Button>
            </div>
        </header>
    )
}

export default Header
